import { defineComponent as _defineComponent } from 'vue'
import SVGWhatsApp from '@/components/svg/SVGWhatsApp.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'WhatsAppMetaHeader',
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, required: false },
    statusLabel: { type: String, required: false },
    statusVariant: { type: String, required: false },
    summary: { type: String, required: false }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();



const __returned__ = { SVGWhatsApp }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})